import React from "react";
import { DataTable } from "react-native-paper";
import { TableValueCellComponent } from "./Types";

export const TableSimpleValueCell: TableValueCellComponent = ({
  field,
  value,
  t,
}) => {
  return (
    <DataTable.Cell style={{ flex: field.width || 1 }}>
      {t(value)}
    </DataTable.Cell>
  );
};
